export default {
  computed: {
    animationName: function () {
      if (this.direction > 0) return "swipeToLeft"
      else if (this.direction < 0) return "swipeToRight"
    },
  },
  props: {
    direction: {
      type: Number,
      required: true,
    },
    mode: {
      default: function () {
        return "out-in"
      },
      type: String,
    },
  },
}
